import { render, staticRenderFns } from "./UrunTurBolgeAlisSaatler.vue?vue&type=template&id=d4cc6b24&scoped=true"
import script from "./UrunTurBolgeAlisSaatler.vue?vue&type=script&lang=js"
export * from "./UrunTurBolgeAlisSaatler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cc6b24",
  null
  
)

export default component.exports